import { ChartNoAxesCombined } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface BarLineChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const BarLineChartIcon: React.FC<BarLineChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <ChartNoAxesCombined size={size} color={color} />
        </IconWrapper>
    );
};
